<template>
  <div id="zonecon-individual-award-edit" class="professional-award-form">
    <!-- Professional Overlay Loading -->
    <v-overlay :value="OverlayLoadingFlag" class="professional-overlay">
      <div class="loading-container">
        <v-progress-circular
          indeterminate
          size="64"
          width="4"
          color="#1976d2"
        ></v-progress-circular>
        <p class="loading-text mt-4">Processing your award application...</p>
      </div>
    </v-overlay>

    <!-- Professional Main Container -->
    <v-card class="main-form-container" elevation="4">
      <!-- Professional Header Section -->
      <v-card-title class="professional-form-header pa-6">
        <div class="header-content">
          <div class="title-section">
            <div class="main-title-wrapper">
              <v-icon size="32" color="#1976d2" class="mr-3">mdi-trophy</v-icon>
              <div class="title-text">
                <h1 class="form-main-title">{{ PageTitle }}</h1>
                <div class="award-badge mt-2" v-if="row != ''">
                  <v-chip color="#ff9800" text-color="white" small>
                    <v-icon left size="14">mdi-star</v-icon>
                    {{ row.AwardTypeTitleTxt }}
                  </v-chip>
                </div>
              </div>
            </div>
          </div>

          <div class="action-buttons">
            <router-link to="/zone/individual-award/list">
              <v-btn
                color="#ff9800"
                elevation="2"
                rounded
                class="action-btn mr-3 white--text"
              >
                <v-icon left size="18">mdi-arrow-left</v-icon>
                Back
              </v-btn>
            </router-link>
            <v-btn
              @click.prevent="refreshPageData"
              color="#2ecc71"
              elevation="2"
              rounded
              class="action-btn white--text"
            >
              <v-icon left size="18">mdi-refresh</v-icon>
              Refresh
            </v-btn>
          </div>
        </div>

        <!-- Professional Description Section -->
        <div class="description-section mt-4" v-if="PageDescription">
          <div class="description-wrapper">
            <v-icon size="20" color="#666" class="mr-2"
              >mdi-information-outline</v-icon
            >
            <p class="form-description">{{ PageDescription }}</p>
          </div>
        </div>
      </v-card-title>

      <!-- Professional Content Container -->
      <v-card-text class="form-main-content pa-6">
        <v-container>
          <!-- Professional Loading Section -->
          <div class="form-loading-section" v-if="LoadingFlag">
            <div class="loading-wrapper">
              <v-progress-circular
                indeterminate
                color="#1976d2"
                size="48"
                width="4"
              ></v-progress-circular>
              <p class="loading-text mt-4">Loading award details...</p>
            </div>
          </div>

          <!-- Award Details Card -->
          <v-card
            class="award-details-card mb-6"
            elevation="3"
            v-if="row != ''"
          >
            <v-card-title class="award-details-header">
              <v-icon size="24" color="#1976d2" class="mr-3"
                >mdi-certificate</v-icon
              >
              <span class="section-title">Award Details</span>
            </v-card-title>
            <v-card-text class="pa-6">
              <v-row>
                <v-col cols="12" md="4">
                  <div class="detail-item">
                    <div class="detail-label">Award Status</div>
                    <div class="detail-value">
                      <v-chip
                        :color="row.AwardStatusColor"
                        text-color="white"
                        class="status-chip"
                      >
                        {{ row.AwardStatusTxt }}
                      </v-chip>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" md="4">
                  <div class="detail-item">
                    <div class="detail-label">Award Register Number</div>
                    <div class="detail-value">
                      {{ row.AwardRegisterNumber }}
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" md="4">
                  <div class="detail-item">
                    <div class="detail-label">Award Title</div>
                    <div class="detail-value">{{ row.AwardTypeTitleTxt }}</div>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <!-- Professional Form Container -->
          <v-form
            ref="form1"
            v-model="valid1"
            lazy-validation
            v-on:submit.prevent="getTotalZoneConIndividualAwardsDetails"
            class="professional-form"
          >
            <!-- Professional Form Content Wrapper -->
            <div class="form-content-wrapper">
              <!-- Professional Member Selection Card -->
              <v-card class="member-selection-card mb-6" elevation="3">
                <v-card-title class="member-selection-header">
                  <v-icon size="24" color="#1976d2" class="mr-3"
                    >mdi-account-search</v-icon
                  >
                  <span class="section-title">Nominee Selection</span>
                </v-card-title>
                <v-card-text class="pa-6">
                  <v-row>
                    <v-col cols="12" md="6">
                      <div class="input-section">
                        <div class="input-label">
                          <span class="required-indicator">*</span> Select
                          Member
                          <span class="input-hint"
                            >(Only Current Year Dues paid member)</span
                          >
                        </div>
                        <v-autocomplete
                          :reduce="(option) => option.value"
                          :loading="MemberIdOptionsLoading"
                          :items="MemberIdOptions"
                          :rules="MemberIdRules"
                          v-model="MemberId"
                          required
                          outlined
                          dense
                          clearable
                          class="professional-input"
                        >
                          <template v-slot:selection="{ item }">
                            <div class="member-selection-item">
                              <img
                                class="member-avatar mr-2"
                                width="40"
                                height="40"
                                :src="item.photo"
                              />
                              <span>{{ item.text }}</span>
                            </div>
                          </template>
                          <template v-slot:item="{ item }">
                            <div class="member-dropdown-item">
                              <img
                                class="member-avatar mr-2"
                                width="40"
                                height="40"
                                :src="item.photo"
                              />
                              <span>{{ item.text }}</span>
                            </div>
                          </template>
                        </v-autocomplete>
                      </div>
                    </v-col>
                    <v-col cols="12" md="6" v-if="Member.membership_id > 0">
                      <div class="member-details-section">
                        <member-details
                          cardTitle="Award Nominee Member"
                          :Member="Member"
                          class="nominee-card"
                        >
                        </member-details>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <jci-india-scoring-table
                v-if="Member.membership_id > 0"
                :AwardCategoryId="row.AwardCategoryId"
                :MemberId="Member.value"
                :AwardTypeId="row.AwardTypeId"
                :LomId="LomId"
                class="scoring-component"
              ></jci-india-scoring-table>

              <br />

              <!-- Professional Judging Criteria Section -->
              <v-card class="criteria-card mb-6" elevation="3" v-if="row != ''">
                <v-card-title class="criteria-header">
                  <v-icon size="24" color="#1976d2" class="mr-3"
                    >mdi-clipboard-text</v-icon
                  >
                  <span class="section-title">Judging Criteria</span>
                </v-card-title>
                <v-card-text class="pa-6">
                  <!-- Professional Criteria Questions -->
                  <div
                    class="criteria-question-section mb-6"
                    v-for="(item, index) in row.AwardAnswersArray"
                    :key="index"
                  >
                    <!-- Criteria Detail Header -->
                    <div
                      class="criteria-detail-header mb-4"
                      v-if="item.CriteriaTitleFlag"
                    >
                      <div class="criteria-detail-card">
                        <div class="criteria-detail-content">
                          <h3 class="criteria-title">
                            {{ item.CriteriaTitle }}
                            <small> (score - {{ item.CriteriaScore }}) </small>
                          </h3>
                        </div>
                      </div>
                    </div>

                    <!-- Question Content -->
                    <div class="question-content-wrapper">
                      <div class="question-label-section mb-2">
                        <h6 class="question-title">
                          <span class="required-indicator">*</span>
                          {{ item.QuestionsText }}
                        </h6>
                      </div>

                      <div class="question-input-section mb-4">
                        <div class="html-editor-wrapper">
                          <vue-editor
                            :id="item.AnswerId"
                            v-model="item.AnswerText"
                            :editorOptions="editorOptions"
                            @text-change="onTextChange($event, item)"
                            placeholder="Please provide your detailed answer here..."
                            class="professional-editor"
                          ></vue-editor>
                          <div class="character-counter mt-1 text-right" 
                               :class="{'error--text': getCharacterCount(item.AnswerText) >= item.QuestionsCharsCount}">
                            <strong>{{ getCharacterCount(item.AnswerText) }}</strong> / {{ item.QuestionsCharsCount }}
                            <span v-if="getCharacterCount(item.AnswerText) >= item.QuestionsCharsCount" class="limit-message">
                              (Character limit reached)
                            </span>
                          </div>
                        </div>
                      </div>

                      <!-- Attachments Section -->
                      <div class="attachments-section mt-5">
                        <div class="attachments-header">
                          <h3 class="attachments-title">
                            <v-icon size="20" color="#ff9800" class="mr-2"
                              >mdi-paperclip</v-icon
                            >
                            Attachments
                            <small
                              >(Max:
                              {{ item.QuestionsAttachmentMax }})</small
                            >
                          </h3>

                          <v-btn
                            color="primary"
                            fab
                            small
                            elevation="2"
                            class="add-attachment-btn"
                            v-if="
                              item.QuestionsAttachmentMax >
                              item.EventDetails.length
                            "
                            @click="addNewRow(item)"
                          >
                            <v-icon>mdi-plus</v-icon>
                          </v-btn>
                        </div>

                        <div
                          class="attachments-grid mt-4"
                          v-if="item.EventDetails.length > 0"
                        >
                          <v-row>
                            <v-col
                              v-for="(data, dataIndex) in getValidEventDetails(
                                item.EventDetails
                              )"
                              cols="12"
                              sm="6"
                              md="4"
                              lg="3"
                              :key="dataIndex"
                              class="attachment-item"
                            >
                              <v-card class="attachment-card" elevation="2">
                                <div class="attachment-actions">
                                  <v-btn
                                    icon
                                    small
                                    color="error"
                                    @click="deleteRow(item.SNo, dataIndex)"
                                    class="delete-btn"
                                  >
                                    <v-icon>mdi-delete</v-icon>
                                  </v-btn>
                                </div>

                                <v-card-text class="pa-4">
                                  <div class="event-images text-center mb-3">
                                    <viewer
                                      rebuild
                                      :images="data.EventImagesArray"
                                    >
                                      <div class="images-grid">
                                        <img
                                          class="event-image"
                                          width="100"
                                          height="100"
                                          :src="src"
                                          :key="src"
                                          v-for="src in data.EventImagesArray"
                                        />
                                      </div>
                                    </viewer>
                                  </div>

                                  <div class="event-details">
                                    <div class="detail-row mb-2">
                                      <v-icon
                                        size="16"
                                        color="#666"
                                        class="mr-1"
                                        >mdi-calendar</v-icon
                                      >
                                      <span class="detail-label"
                                        >Event Date:</span
                                      >
                                      <span class="detail-value">{{
                                        data.EventDate
                                      }}</span>
                                    </div>

                                    <div class="detail-row">
                                      <v-icon
                                        size="16"
                                        color="#666"
                                        class="mr-1"
                                        >mdi-tag</v-icon
                                      >
                                      <span class="detail-label"
                                        >Event Name:</span
                                      >
                                      <span class="detail-value">{{
                                        data.EventName
                                      }}</span>
                                    </div>
                                  </div>
                                </v-card-text>
                              </v-card>
                            </v-col>
                          </v-row>
                        </div>

                        <div class="no-attachments-state mt-4" v-else>
                          <v-alert
                            type="info"
                            text
                            color="grey lighten-1"
                            outlined
                            dense
                          >
                            No attachments added yet. Click the + button to add
                            an attachment.
                          </v-alert>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-card-text>
              </v-card>

              <!-- Empty State for No Criteria -->
              <v-card v-if="row === ''" class="empty-state-card" elevation="3">
                <v-card-text class="text-center pa-6">
                  <v-icon size="64" color="#ccc">mdi-clipboard-outline</v-icon>
                  <h3 class="empty-state-title mt-4">
                    No Award Details Available
                  </h3>
                  <p class="empty-state-text">
                    Please wait while we load the award details or try
                    refreshing the page.
                  </p>
                </v-card-text>
              </v-card>

              <!-- Professional Submit Section -->
              <div class="submit-section" v-if="row != ''">
                <v-card class="submit-card" elevation="3">
                  <v-card-text class="text-center pa-6">
                    <div class="submit-info mb-4">
                      <h3 class="submit-title">Ready to Submit?</h3>
                      <p class="submit-description">
                        You can save your progress or submit your award
                        application when complete.
                      </p>
                    </div>

                    <div class="action-buttons">
                      <v-btn
                        @click.prevent="confirmAlert(4)"
                        :loading="SaveFlag"
                        color="#1db954"
                        elevation="3"
                        rounded
                        class="submit-btn mr-3 white--text"
                      >
                        <v-icon left>mdi-content-save</v-icon>
                        Save Progress
                      </v-btn>

                      <v-btn
                        :disabled="!valid1"
                        @click.prevent="confirmAlert(3)"
                        :loading="SubmitFlag"
                        color="#1976d2"
                        elevation="3"
                        rounded
                        class="submit-btn white--text"
                      >
                        <v-icon left>mdi-check-circle</v-icon>
                        Final Submit
                      </v-btn>
                    </div>
                  </v-card-text>
                </v-card>
              </div>
            </div>
          </v-form>
        </v-container>
      </v-card-text>
    </v-card>

    <!-- Professional Dialog -->
    <v-dialog
      v-model="addRecordPrompt"
      persistent
      max-width="800px"
      transition="dialog-transition"
      overlay-opacity="0.7"
    >
      <answer-attachment-edit
        pageTitle="Add Project Details"
        :recordData="selectedRecord"
        :addRecordPrompt="addRecordPrompt"
        @hideAddRecordPrompt="hideAddRecordPrompt($event)"
        v-if="addRecordPrompt"
      ></answer-attachment-edit>
    </v-dialog>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";
import { VueEditor } from "vue2-editor"; // Import Vue-Quill-Editor

import AnswerAttachmentEdit from "@/view/pages/erp/jci-award/zonecon/common/AnswerAttachmentEdit.vue";
import MemberDetails from "@/view/pages/erp/jci-award/zonecon/common/MemberDetails.vue";

export default {
  mixins: [common],
  components: { AnswerAttachmentEdit, MemberDetails, VueEditor },
  data() {
    return {
      valid1: true,
      valid2: true,
      LoadingFlag: false,
      OverlayLoadingFlag: false,
      SaveFlag: false,
      SubmitFlag: false,
      SearchFlag: false,
      ResultFlag: false,
      CardLoadingFlag: false,
      UploadFlag: false,
      addButtonFlag: true,
      editorOptions: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote'],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            [{ 'indent': '-1'}, { 'indent': '+1' }],
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{ 'color': [] }, { 'background': [] }],
            ['clean']
          ]
        },
        placeholder: 'Please provide your detailed answer here...',
      },

      MemberIdRules: [(v) => !!v || "Member is required"],
      MemberId: "",
      MemberIdOptions: [],
      MemberIdOptionsLoading: false,

      Member: {},

      Status: "",

      ZoneconIndividualAwardStartDate: "",
      ZoneconIndividualAwardEndDate: "",
      TotalZoneconIndividualAward: 0,
      TotalApplied: 0,
      TotalPartiallySaved: 0,

      StartDateFlag: false,
      EndDateFlag: false,

      CurrentDateTime: "",
      CurrentDate: "",
      CurrentTime: "",
      CurrentAmPm: "",

      rows: {},

      AwardId: "",
      AwardTypeId: "",

      row: {},
      // CriteriaAnswers: [],
      Project: [],

      selectedRecord: "",
      Id: "",
      showTextBox: false,

      addRecordPrompt: false,

      ImageUploadFlag: false,

      AnswerRules: [(v) => !!v || "Answer is required"],

      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      CurrentYearId: 0,
      LomId: "",
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
    };
  },
  computed: {
    // Returns only event details with non-empty EventId
    getValidEventDetails() {
      return function (eventDetails) {
        return eventDetails.filter((item) => item.EventId !== "");
      };
    },
  },
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        var flag = tr.PagePermissionFlag;
        console.log("PagePermissionFlag=" + flag);

        if (!flag) {
          this.$router.push("/access-denied");
        }

        var zone_name = this.$session.get("ZoneName");
        zone_name = zone_name == (null || undefined) ? 0 : zone_name;

        var LomId = this.$session.get("LomId");
        LomId = LomId == (null || undefined) ? 0 : LomId;
        this.LomId = LomId;

        this.PageTitle = tr.PageTitle + " - " + zone_name;
        this.PageDescription = tr.PageDescription;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        this.CurrentYearId = CurrentJciYearId;

        this.pageData();
      }
    },
    row: function () {
      console.log("watch row called");
      this.getMemberIdOptions();
    },
    MemberIdOptions: function () {
      console.log("watch MemberIdOptions called");
      this.MemberIdOptionsLoading = false;
      this.MemberId = this.row.MemberId;
    },
    MemberId: function () {
      console.log("MemberId watch called");
      this.Member = {};
      this.getSelectedMemberDetails();
    },
    rows: function () {
      console.log("watch rows called");
      this.getCurrentDateTime();
    },
    CurrentDateTime: function () {
      console.log("watch CurrentDateTime called");
      this.getDeadlineDetails();
    },
  },
  mounted() {},
  methods: {
    // HTML Editor related methods
    getCharacterCount(html) {
      if (!html) return 0;
      // Remove HTML tags and entities to count only visible text
      const text = html.replace(/<[^>]*>|&nbsp;|&amp;|&lt;|&gt;|&quot;|&#39;/g, '');
      return text.length;
    },

    onTextChange(event, item) {
      // Get the Quill editor instance from the event
      const editor = event.editor;
      const maxLength = item.QuestionsCharsCount;

      // Calculate the current text length without HTML tags
      const currentLength = this.getCharacterCount(item.AnswerText);

      // If the length exceeds the limit, prevent further input
      if (currentLength > maxLength) {
        // Get the current selection
        const range = editor.getSelection();

        // If there is no selection, we need to restore the previous text
        if (range && range.length === 0) {
          // Store current cursor position
          const cursorPosition = range.index;
          
          // Use DOM manipulation to truncate the HTML content
          const editorRoot = editor.root;
          const editorContent = editorRoot.innerHTML;
          
          // Create a temporary div to manipulate the HTML
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = editorContent;
          
          // Function to recursively process text nodes
          const processNode = (node, currentCount) => {
            if (currentCount >= maxLength) {
              // Remove node completely if we're already at the limit
              if (node.parentNode) {
                node.parentNode.removeChild(node);
              }
              return currentCount;
            }
            
            if (node.nodeType === Node.TEXT_NODE) {
              const nodeLength = node.textContent.length;
              if (currentCount + nodeLength > maxLength) {
                // Truncate this text node
                const remainingChars = maxLength - currentCount;
                node.textContent = node.textContent.substring(0, remainingChars);
                return maxLength;
              } else {
                return currentCount + nodeLength;
              }
            } else if (node.nodeType === Node.ELEMENT_NODE) {
              // Skip certain elements that don't contribute to visible text
              if (node.tagName === 'SCRIPT' || node.tagName === 'STYLE') {
                return currentCount;
              }
              
              // Process child nodes
              let count = currentCount;
              const childNodes = Array.from(node.childNodes);
              for (const childNode of childNodes) {
                count = processNode(childNode, count);
                if (count >= maxLength) break;
              }
              return count;
            }
            
            return currentCount;
          };
          
          // Process the content
          processNode(tempDiv, 0);
          
          // Update the editor content
          editor.setContents(editor.clipboard.convert(tempDiv.innerHTML));
          
          // Restore cursor position, but don't go beyond the new content
          const newLength = editor.getText().length;
          const newPosition = Math.min(cursorPosition, newLength - 1);
          editor.setSelection(newPosition > 0 ? newPosition : 0);
        }
      }

      // Update validation rules
      if (currentLength >= maxLength) {
        if (!this.AnswerRules.includes(this.validateMaxLength)) {
          this.AnswerRules.push(this.validateMaxLength);
        }
      } else {
        const index = this.AnswerRules.indexOf(this.validateMaxLength);
        if (index !== -1) {
          this.AnswerRules.splice(index, 1);
        }
      }
    },

    validateMaxLength(v) {
      // This is a custom validation rule for the rich text editor
      // It will be used by Vuetify's validation system
      const item = this.row.AwardAnswersArray.find(item => item.AnswerText === v);
      if (item && this.getCharacterCount(v) > item.QuestionsCharsCount) {
        return 'Character limit exceeded';
      }
      return true;
    },

    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "zone_individual_award",
        Action: "edit",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
    },
    pageData() {
      console.log("pageData called");
      var id = this.$route.query.id;
      console.log({ id });
      this.AwardId = id;

      this.getTableRecords();
    },
    getMemberIdOptions() {
      console.log("getMemberIdOptions called");
      this.MemberIdOptionsLoading = true;
      var selectbox1_source = "MemberId";
      var selectbox1_destination = "MemberIdOptions";
      var selectbox1_url = "api/members/options";
      var selectbox1_conditions_array = {
        UserInterface: 7,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getSelectedMemberDetails() {
      console.log("getSelectedMemberDetails called");
      this.Member = {};
      var temp_code = this.MemberId;
      console.log("temp_code=" + temp_code);
      var idx = this.MemberIdOptions.map((e) => e.value).indexOf(temp_code);
      console.log("idx=" + idx);
      if (idx >= 0) {
        var member = this.MemberIdOptions[idx];
        console.log("member=" + JSON.stringify(member));
        this.Member = member;
      }
    },
    resetForm() {
      console.log("resetForm called");
      var rows = this.CriteriaAnswers;

      rows.map((row, index) => {
        row.AnswerText="";
        row.AllProject = {};
      });

      this.getTableRecords();
    },
    addNewRow(tr) {
      console.log("addNewRow called");
      console.log({ tr });
      this.selectedRecord = tr;
      this.addRecordPrompt = true;
    },
    deleteRow(id, index) {
      console.log("deleteRow called");
      console.log({ id });
      console.log({ index });
      if (index > -1) {
        var row = this.row.AwardAnswersArray;

        row.forEach((data, k) => {
          console.log({ k });
          if (id == k) {
            data.EventDetails.splice(index, 1);
          }
        });

        console.log("row = ", this.row);
      }
    },
    hideAddRecordPrompt(tr) {
      console.log("hideAddRecordPrompt called");
      this.addRecordPrompt = false;
      console.log({ tr });

      if (tr.EventId != "") {
        // this.Id = tr.Index;
        console.log("tr.index = ", tr.Index);

        var row = this.row.AwardAnswersArray;

        row.forEach((data, index) => {
          console.log("SNo = ", data.SNo);

          if (tr.Index == data.SNo) {
            console.log("Limit not Crossed");

            var n1 = data.QuestionsAttachmentMax;
            var n2 = data.EventDetails.length;
            console.log({ n1 }, { n2 });

            if (n1 > n2) {
              console.log("Limit not Crossed");

              data.EventDetails.push({
                EventId: tr.EventId,
                EventName: tr.EventName,
                EventDate: tr.EventDate,
                EventImagesArray: tr.EventPhoto,
              });
            } else {
              console.log("Maximum Limit Crossed");
              var Message = "Attachment Maximum Count reached its limit.";
              this.sweetAlert("error", Message, false);
            }
          }
        });

        console.log("row = ", this.row);
      }
    },
    getTableRecords() {
      console.log("getTableRecords called");

      var AwardId = this.AwardId;
      console.log({ AwardId });

      if (AwardId > 0) {
        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/award/show";
        var upload = {
          UserInterface: 1,
          Award: AwardId,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        this.RecordFlag = false;

        const thisIns = this;
        var output = "";
        var records = "";
        var flag = 0;

        this.LoadingFlag = true;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.LoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            records = response.data.records;
            console.log("records=" + JSON.stringify(records));

            thisIns.RecordFlag = flag;

            if (flag == 1) {
              thisIns.row = records;
              // thisIns.toast("success", output);
            } else {
              // thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.toast("error", error);
            thisIns.LoadingFlag = false;
          });
      } else {
        var message = "Award details not found.";
        console.log("error=" + message);
      }
    },
    getTotalZoneConIndividualAwardsDetails(status) {
      console.log("getTotalZoneConIndividualAwardsDetails called");

      var validate1 = true;
      console.log({ validate1 });

      console.log({ status });
      this.Status = status;

      if (validate1) {
        this.CardLoadingFlag = true;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/award-type/total-awards";

        var AwardCategory = 2;
        var AwardGroup = 1;

        if (this.RoleId == 2) {
          // For Admin
          var upload = {
            UserInterface: 2,
            AwardCategory: AwardCategory,
            AwardGroup: AwardGroup,
            Zone: this.ZoneCode,
            Lom: this.LomCode,
          };
        } else {
          // For Others
          var upload = {
            UserInterface: 2,
            AwardCategory: AwardCategory,
            AwardGroup: AwardGroup,
          };
        }

        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.CardLoadingFlag = false;

            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            if (flag == 1) {
              console.log("records = " + JSON.stringify(records));
              thisIns.rows = records;
              thisIns.ZoneconIndividualAwardStartDate = records.StartDateTxt;
              thisIns.ZoneconIndividualAwardEndDate = records.EndDateTxt;
              thisIns.TotalZoneconIndividualAward = records.TotalAward;
              thisIns.TotalApplied = records.TotalApplied;
              thisIns.TotalPartiallySaved = records.TotalPartiallySaved;
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            thisIns.CardLoadingFlag = false;
            console.log("error=" + error);
            thisIns.toast("error", error);
          });
      } else {
        var message = "";
        console.log("error=" + message);
      }
    },
    getCurrentDateTime() {
      console.log("getCurrentDateTime called");

      // Get new date
      var dateObj = new Date();

      var temp_date = String(dateObj.getDate()).padStart(2, "0");
      var month = String(dateObj.getMonth() + 1).padStart(2, "0");
      var year = dateObj.getFullYear();

      // Get Current Date
      var current_date = year + "-" + month + "-" + temp_date;

      // var temp_hour = String(dateObj.getHours()).padStart(2, "0") % 12;
      // var hour = temp_hour ? temp_hour : 12;
      var hour = String(dateObj.getHours()).padStart(2, "0");
      var minute = String(dateObj.getMinutes()).padStart(2, "0");
      var second = String(dateObj.getSeconds()).padStart(2, "0");

      // Get Current Time
      var current_time = hour + ":" + minute + ":" + second;

      // Get Current AM/PM
      // var current_am_pm = dateObj.getHours() >= 12 ? "pm" : "am";

      console.log({ current_date }, { current_time });

      this.CurrentDate = current_date;
      this.CurrentTime = current_time;
      // this.CurrentAmPm = current_am_pm;

      var current_date_time = current_date + " " + current_time;

      this.CurrentDateTime = current_date_time;
    },
    getDeadlineDetails() {
      console.log("getDeadlineDetails called");

      // this.CurrentDateTime = "2023-07-01 23:00:00";
      var current_date_time = Date.parse(this.CurrentDateTime);
      console.log({ current_date_time });

      var tr = this.rows;

      // Np-Recognition Start Date
      var temp_start_date_time = tr.StartDate1;
      // temp_start_date_time = "2023-07-01 00:00:01";
      var start_date_time = Date.parse(temp_start_date_time);
      console.log({ temp_start_date_time }, { start_date_time });

      if (start_date_time <= current_date_time) {
        console.log("Opened");
        this.StartDateFlag = true;
      } else {
        console.log("Closed");
      }

      // Np-Recognition End Date

      var temp_end_date_time = tr.EndDate1;
      var end_date_time = Date.parse(temp_end_date_time);
      console.log({ temp_end_date_time }, { end_date_time });

      if (end_date_time > current_date_time) {
        console.log("Opened");
        this.EndDateFlag = true;
      } else {
        console.log("Closed");
      }

      console.log("StartDateFlag = ", this.StartDateFlag);
      console.log("EndDateFlag = ", this.EndDateFlag);
      // this.StartDateFlag = false;
      if (this.StartDateFlag && this.EndDateFlag && this.Status != "") {
        this.confirmAlert(this.Status);
      } else {
        this.deadlineAlert();
      }
    },
    deadlineAlert() {
      console.log("deadlineAlert called");
      var htmlTxt = "";
      htmlTxt +=
        "<h3> Zonecon LO Awards Bidding ended at <b> " +
        this.ZoneconIndividualAwardEndDate +
        " </b> </h3>";
      // htmlTxt += "<br/> Start <b> " + this.ZoneconIndividualAwardEndDate + " </b>";

      Swal.fire({
        title: "Sorry !",
        text: "",
        icon: "warning",
        html: htmlTxt,
      });
    },
    confirmAlert(status) {
      console.log("confirmAlert called");

      var validate1 = false;
      validate1 = status == 4 ? true : this.$refs.form1.validate();
      console.log("validate1=" + validate1);

      this.MemberId =
        this.MemberId == null || this.MemberId == "" ? "" : this.MemberId;

      console.log("MemberId =", this.MemberId);

      var PhotoFlag = this.Member.photo_flag;
      console.log({ PhotoFlag });

      // var DocumentFlag = this.Member.document_flag;
      var DocumentFlag = true;
      console.log({ DocumentFlag });

      if (this.MemberId != "" && validate1 && PhotoFlag && DocumentFlag) {
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: `Save`,
          confirmButtonColor: "#3085d6",
          cancelButtonText: `Cancel`,
          cancelButtonColor: "#d33",
        }).then((result) => {
          if (result.isConfirmed) {
            this.submitForm(status);
          } else {
            this.sweetAlert("error", "You cancelled the process", false);
          }
        });
      } else {
        var message = "";
        if ((this.MemberId = "" || this.MemberId == null) && !validate1) {
          message = "Kindly select member and fill all the Questions";
        }
        if (this.MemberId == "" || this.MemberId == null) {
          message = "Kindly select Member";
        }
        if (!validate1) {
          message = "Kindly fill all the Questions";
        }
        if (!PhotoFlag) {
          message = "Member Profile not Updated.";
        }
        if (!DocumentFlag) {
          message = "Age document not Updated.";
        }
        console.log({ message });
        this.sweetAlert("error", message, false);
      }
    },
    submitForm(status) {
      console.log("submitForm is called");
      this.OverlayLoadingFlag = true;

      console.log({ status });

      var upload = {
        UserInterface: 1,
        ActiveStatus: status,
        Member: this.MemberId,
        AwardGroup: 1,
        AwardCategory: 2,
        ZoneCon: true,
        Award: this.AwardId,
        CriteriaAnswers: this.row,
      };
      console.log("upload=" + JSON.stringify(upload));

      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;

      var add_url = server_url + "api/award/update";
      console.log(
        "server_url=" + server_url + ", token=" + token + ", add_url=" + add_url
      );

      if (status == 4) {
        this.SaveFlag = true;
      } else {
        this.SubmitFlag = true;
      }

      const thisIns = this;
      var output = "";
      var records = "";
      var flag = 0;

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(
            Math.round((progressEvent.loaded / progressEvent.total) * 100)
          );
        }.bind(this),
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));

          thisIns.OverlayLoadingFlag = false;
          if (status == 4) {
            thisIns.SaveFlag = false;
          } else {
            thisIns.SubmitFlag = false;
          }

          output = response.data.output;
          flag = response.data.flag;
          console.log("output=" + output + ", flag=" + flag);
          records = response.data.records;
          console.log({ records });

          if (flag == 1) {
            thisIns.sweetAlert("success", output, true);

            thisIns.$router.push("/zone/individual-award/list");
          } else {
            thisIns.sweetAlert("error", output, false);
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          thisIns.OverlayLoadingFlag = false;
          if (status == 4) {
            thisIns.SaveFlag = false;
          } else {
            thisIns.SubmitFlag = false;
          }
        });
    },
  },

  beforeMount() {
    this.refreshPageData();
  },
};
</script>
<style lang="scss">
// Professional Award Form Styles
#zonecon-individual-award-edit {
  background-color: #f5f7fa;
  min-height: 100vh;

  // HTML Editor Styles
  .html-editor-wrapper {
    border: 1px solid #e0e0e0;
    border-radius: 4px;

    .professional-editor {
      .ql-container {
        min-height: 150px;
        font-family: inherit;
        font-size: 1rem;
      }

      .ql-toolbar {
        border-bottom: 1px solid #e0e0e0;
        background-color: #f8f9fa;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
      }
    }

    .character-counter {
      padding: 4px 12px;
      font-size: 0.75rem;
      color: rgba(0,0,0,0.6);
      background-color: #f8f9fa;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      transition: all 0.3s ease;

      &.error--text {
        color: #f44336;
        background-color: rgba(244, 67, 54, 0.1);
        font-weight: 500;

        .limit-message {
          animation: pulse 1.5s infinite;
          display: inline-block;
        }
      }

      @keyframes pulse {
        0% { opacity: 0.6; }
        50% { opacity: 1; }
        100% { opacity: 0.6; }
      }
    }
  }

  // Professional Overlay
  .professional-overlay {
    .loading-container {
      text-align: center;
      color: white;

      .loading-text {
        font-size: 1.1rem;
        font-weight: 500;
        margin: 0;
      }
    }
  }

  // Main Form Container
  .main-form-container {
    border-radius: 12px !important;
    overflow: hidden;
    background: white;
    box-shadow: 0 6px 30px rgba(0, 0, 0, 0.1) !important;
  }

  // Professional Header Styles
  .professional-form-header {
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
    border-bottom: 1px solid #e3f2fd;

    .header-content {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      width: 100%;

      .title-section {
        flex: 1;

        .main-title-wrapper {
          display: flex;
          align-items: center;

          .title-text {
            .form-main-title {
              font-size: 2rem;
              font-weight: 700;
              color: #2c3e50;
              margin: 0;
              font-family: "Roboto", sans-serif;
              line-height: 1.2;
            }

            .award-badge {
              margin-top: 0.5rem;
            }
          }
        }
      }

      .action-buttons {
        display: flex;
        gap: 0.5rem;

        .action-btn {
          font-weight: 500;
          text-transform: none;
          padding: 0 20px;
          height: 40px;

          &:hover {
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          }
        }
      }
    }

    .description-section {
      .description-wrapper {
        display: flex;
        align-items: center;
        background: rgba(25, 118, 210, 0.05);
        padding: 1rem;
        border-radius: 8px;
        border-left: 4px solid #1976d2;

        .form-description {
          font-size: 1.1rem;
          color: #424242;
          margin: 0;
          font-weight: 400;
        }
      }
    }
  }

  // Form Content Styles
  .form-main-content {
    background: #f5f7fa;
  }

  // Form Loading
  .form-loading-section {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 200px;

    .loading-wrapper {
      text-align: center;

      .loading-text {
        font-size: 1.1rem;
        color: #666;
        font-weight: 500;
        margin: 0;
      }
    }
  }

  // Award Details Card
  .award-details-card {
    border-radius: 12px !important;
    border: 1px solid #e0e0e0;
    overflow: hidden;

    .award-details-header {
      background: linear-gradient(135deg, #fff 0%, #f8f9fa 100%);
      border-bottom: 1px solid #e0e0e0;
      padding: 1.5rem;

      .section-title {
        font-size: 1.3rem;
        font-weight: 600;
        color: #2c3e50;
      }
    }

    .detail-item {
      margin-bottom: 0.5rem;

      .detail-label {
        font-size: 0.9rem;
        color: #666;
        margin-bottom: 0.25rem;
        font-weight: 500;
      }

      .detail-value {
        font-size: 1.1rem;
        color: #2c3e50;
        font-weight: 600;
      }

      .status-chip {
        font-weight: 600;
        height: 32px;
      }
    }
  }

  // Professional Form
  .professional-form {
    .form-content-wrapper {
      .member-selection-card,
      .criteria-card,
      .submit-card,
      .empty-state-card {
        border-radius: 12px !important;
        border: 1px solid #e0e0e0;
      }
    }
  }

  // Member Selection Card
  .member-selection-card {
    .member-selection-header {
      background: linear-gradient(135deg, #fff 0%, #f8f9fa 100%);
      border-bottom: 1px solid #e0e0e0;
      padding: 1.5rem;

      .section-title {
        font-size: 1.3rem;
        font-weight: 600;
        color: #2c3e50;
      }
    }

    .input-section {
      .input-label {
        font-size: 1rem;
        font-weight: 600;
        color: #2c3e50;
        margin-bottom: 0.5rem;

        .required-indicator {
          color: #f44336;
          margin-right: 0.25rem;
        }

        .input-hint {
          color: #666;
          font-weight: 400;
          font-size: 0.85rem;
        }
      }

      .professional-input {
        margin-bottom: 0.5rem;
      }

      .member-selection-item,
      .member-dropdown-item {
        display: flex;
        align-items: center;
        padding: 0.5rem 0;

        .member-avatar {
          border-radius: 50%;
          border: 2px solid #e0e0e0;
          object-fit: cover;
        }
      }
    }

    .member-details-section {
      .nominee-card {
        border-radius: 8px;
        overflow: hidden;
      }
    }
  }

  // Criteria Card
  .criteria-card {
    .criteria-header {
      background: linear-gradient(135deg, #fff 0%, #f8f9fa 100%);
      border-bottom: 1px solid #e0e0e0;
      padding: 1.5rem;

      .section-title {
        font-size: 1.3rem;
        font-weight: 600;
        color: #2c3e50;
      }
    }

    .criteria-question-section {
      .criteria-detail-header {
        .criteria-detail-card {
          display: flex;
          align-items: center;
          background: #fff3e0;
          border: 1px solid #ffb74d;
          border-radius: 8px;
          padding: 1rem;

          .criteria-detail-content {
            flex: 1;

            .criteria-title {
              font-size: 1.2rem;
              font-weight: 600;
              color: #e65100;
              margin: 0 0 0.5rem 0;
            }
          }
        }
      }

      .question-content-wrapper {
        .question-label-section {
          .question-title {
            font-size: 1rem;
            font-weight: 600;
            color: #2c3e50;
            margin: 0;
            line-height: 1.4;

            .required-indicator {
              color: #f44336;
              margin-right: 0.25rem;
            }
          }
        }

        .question-input-section {
          .professional-textarea {
            margin-bottom: 0.5rem;
          }
        }

        .attachments-section {
          .attachments-header {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .attachments-title {
              font-size: 1rem;
              font-weight: 600;
              color: #2c3e50;
              margin: 0;
              display: flex;
              align-items: center;

              small {
                color: #666;
                font-weight: 400;
                margin-left: 0.5rem;
              }
            }

            .add-attachment-btn {
              &:hover {
                transform: scale(1.1);
              }
            }
          }

          .attachments-grid {
            margin-top: 1rem;

            .attachment-item {
              .attachment-card {
                border-radius: 8px !important;
                position: relative;
                transition: transform 0.2s, box-shadow 0.2s;

                &:hover {
                  transform: translateY(-2px);
                  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
                }

                .attachment-actions {
                  position: absolute;
                  top: 0.5rem;
                  right: 0.5rem;
                  z-index: 2;

                  .delete-btn {
                    &:hover {
                      background-color: rgba(244, 67, 54, 0.1);
                    }
                  }
                }

                .event-images {
                  .images-grid {
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: center;
                    gap: 0.5rem;

                    .event-image {
                      border-radius: 4px;
                      border: 1px solid #e0e0e0;
                      object-fit: cover;
                      transition: transform 0.2s;

                      &:hover {
                        transform: scale(1.05);
                      }
                    }
                  }
                }

                .event-details {
                  .detail-row {
                    display: flex;
                    align-items: center;
                    font-size: 0.9rem;
                    color: #666;

                    .detail-label {
                      font-weight: 600;
                      color: #555;
                      margin-right: 0.25rem;
                    }

                    .detail-value {
                      color: #2c3e50;
                      font-weight: 500;
                    }
                  }
                }
              }
            }
          }

          .no-attachments-state {
            text-align: center;
            padding: 2rem;
            color: #999;
          }
        }
      }
    }
  }

  // Submit Section
  .submit-section {
    margin-top: 2rem;

    .submit-card {
      border: 2px solid #e3f2fd;
      background: linear-gradient(135deg, #fff 0%, #f8f9fa 100%);

      .submit-info {
        .submit-title {
          font-size: 1.4rem;
          font-weight: 600;
          color: #2c3e50;
          margin: 0;
        }

        .submit-description {
          color: #666;
          margin: 0.5rem 0 0 0;
        }
      }

      .action-buttons {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 1rem;

        .submit-btn {
          min-width: 150px;
          font-weight: 600;
          text-transform: none;
          border-radius: 8px;

          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
          }
        }
      }
    }
  }

  // Empty State
  .empty-state-card {
    .empty-state-title {
      font-size: 1.3rem;
      font-weight: 600;
      color: #666;
      margin: 0;
    }

    .empty-state-text {
      color: #999;
      margin: 0.5rem 0 0 0;
    }
  }

  // Responsive Design
  @media (max-width: 1024px) {
    .professional-form-header {
      .header-content {
        flex-direction: column;
        gap: 1rem;

        .action-buttons {
          align-self: flex-start;
        }
      }
    }
  }

  @media (max-width: 768px) {
    .main-form-container {
      margin: 0.5rem;
      border-radius: 8px !important;
    }

    .professional-form-header {
      padding: 1rem !important;

      .header-content
        .title-section
        .main-title-wrapper
        .title-text
        .form-main-title {
        font-size: 1.5rem;
      }
    }

    .form-main-content {
      padding: 1rem !important;
    }

    .action-buttons {
      flex-direction: column;

      .submit-btn {
        width: 100%;
        margin: 0.25rem 0 !important;
      }
    }

    .attachments-grid {
      .attachment-item {
        .attachment-card {
          .event-details {
            .detail-row {
              font-size: 0.8rem;
            }
          }
        }
      }
    }
  }
}
</style>
